import {noticeConstants} from "../../constants";

const initialState ={
    date: [],
    status: [],
    select: [],
    prev:{},
    next:{},
    recordItems:[],
    isLoading: false,
    isFailure: false,
    page: 0,

}

export default function notice(state = initialState, action){
    switch (action.type){
        /******
         리스트
         *****/
        case noticeConstants.LOAD_REQUEST:
            return{
                ...state,
                isLoading: !state.isLoading
            }
        case noticeConstants.LOAD_SUCCESS:
            let data = action.response.data.payload;
            data.schCode = action.params?.schCode;
            data.schText = action.params?.schText;

            return{
                ...state,
                data: data,
            }
        case noticeConstants.LOAD_FAILURE:
            return{
                isLoading: false,
                isFailure: true,
            }

        /*******
         상세화면
         **********/

        case noticeConstants.DETAILS_REQUEST:
            return {
                ...state,
                isLoading:  !state.isLoading
            }
        case noticeConstants.DETAILS_SUCCESS:
            return {
                ...state,
                select: action.response.data.payload?.content,
                prev: action.response.data.payload?.prev,
                next: action.response.data.payload?.next,
            }
        case noticeConstants.DETAILS_FAILURE:
            return{
                isLoading: false,
                isFailure: true,
            }


        /*******
         선택
          *******/

        case noticeConstants.SELECT_REQUEST:

            window.open('/canvasNew/composeViewer_new.htm?menuId=104&cntrctNo='+action.params,'_blank')

            return{
                ...state,
                isLoading: !state.isLoading,
            }
        default:
            return state
    }
}